import { Autocomplete, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Config from '../../../config';
import setToast from '../../../helpers/toaster.helper';
import { IntegrationGridEmptyIcon, IntegrationBlueIcon, DeleteChatIcon, SlackIntCircleIcon, SlackCircleSmallIcon } from '../../../icon';
import { PhoneNumberModel, PhoneNumberStatus } from '../../../models/phone-number.model';
import * as selector from '../../../selectors/selectors';
import { IntegrationSetupService } from '../../../services/IntegrationSetup';
import { UserService } from '../../../services/UserService';
import ButtonComponent from '../../shared/button/button.component';
import { buttonLabels } from '../../shared/constants';
import { ToasterType } from '../../shared/toaster/toaster.model';
import { UtilityService } from '../../../services/UtilityService';
import { mapToSlackChannels, SlackChannels } from '../../../models/slack';
import * as selectors from '../../../selectors/selectors'

interface IProps {
    isIntegrationSuccess: boolean;
    HandleClick: () => void;
}

const IntegrateSlackChannels = (props: IProps) => {
    const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers);
    const IsTeamsApp: boolean = useSelector(selectors.isTeamsApp)

    const [data, setData] = useState<SlackChannels[]>([])
    const [phoneNumberOptions, setPhoneNumberOptions] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const onClickLinkChannel = (info: SlackChannels) => {
        const payload = {
            channelId: info.ChannelId,
            phoneNumber: info.PhoneNumber,
            userId: UserService.getCurrentUserId(),
            userName: `${info.TeamName}${info.ChannelName}`,
            orgId: UserService.getCurrentUserOrgId(),
            orgRef: UserService.getCurrentUserOrgRef(),
            phoneNumberId: info.PhoneNumberId,
            provider: 'Bandwidth'
        }

        IntegrationSetupService.updateSlackChannelPhonenumber(payload)
            .then(res => {
                let updatedData = data.map((x: SlackChannels) => x.Id === res.data.data.id ? { ...x, Status: true } : x)
                setData(updatedData)
                setToast("Channel integrated sucessfully", ToasterType.SUCCESS)
            })
            .catch(err =>
                setToast("Channel integration failed", ToasterType.DANGER))
    }

    const getIntegratedChannelsData = () => {
        IntegrationSetupService.getSlackIntegratedChannelDetails(UserService.getCurrentUserOrgId()).then(res => {
            if (res.data !== null) {
                setData(res.data.map(mapToSlackChannels))
            }
            else {
                setData([])
            }
            setIsLoading(false)
        })
    }

    useEffect(() => {
        if (props.isIntegrationSuccess)
            getIntegratedChannelsData()
    }, [props.isIntegrationSuccess]);

    useEffect(() => {
        if (PhoneNumbers.length > 0)
            setPhoneNumberOptions(PhoneNumbers.filter(x => x.Status === PhoneNumberStatus.ACTIVE).map(y => ({
                label: y.PhoneNumber,
                id: y.ID
            })));
    }, [PhoneNumbers]);

    const onClickDelete = (id) => {
        if (!isLoading) {
            setIsLoading(true)
            IntegrationSetupService.deleteIntegratedSlackChannel(id).then(res => {
                setToast("Channel deleted sucessfully", ToasterType.SUCCESS)
                getIntegratedChannelsData();
            }
            ).catch(err => {
                setToast("Channel deletion failed", ToasterType.DANGER)
                setIsLoading(false)
            })
        }
    }

    const onClickTestIntegration = (id) => {
        IntegrationSetupService.testSlackChannelIntegration(id).then(res =>
            setToast("Test message sent sucessfully", ToasterType.SUCCESS)
        ).catch(err =>
            setToast("Sending test message faild", ToasterType.DANGER)
        )
    }

    return (
        <>
            {props.isIntegrationSuccess &&
                <div className='w-p-100 bg-color-integrate-ms-teams-header py-1'>
                    <div className='ml-3 d-flex justify-between align-center'>
                        <div className='w-p-20 '>
                            <div className='h3-medium'>
                                Slack
                            </div>
                        </div>
                        <div className='w-p-15 ml-2'>

                        </div>
                        <div className='w-p-5 d-flex  justify-center'>
                            <IntegrationBlueIcon />
                        </div>
                        <div className='w-p-20 '>
                            <div className='h3-medium'>
                                Select Falkon SMS
                            </div>
                        </div>
                        <div className='w-p-30 d-flex mx-auto'>
                            <div className="c-pointer mx-auto h4-regular bg-color-secondary w-p-90  br-2 integrate-card-border">
                                {IsTeamsApp ? <div onClick={() => props.HandleClick()} className='d-flex py-1 align-center justify-center'>
                                    <SlackCircleSmallIcon width={25} height={25} />
                                    <div className='ml-1'>Add to Slack</div>
                                </div> : <a href={`https://slack.com/oauth/v2/authorize?client_id=${Config.SLACK_APP_CLIENT_ID}&scope=app_mentions:read,channels:history,channels:join,channels:read,chat:write,commands,files:read,files:write,groups:history,im:history,im:write,incoming-webhook,mpim:history,reactions:write&user_scope=`}>
                                    <div className='d-flex align-center justify-center py-1'>
                                        <SlackCircleSmallIcon width={25} height={25} />
                                        <div className='ml-1'>Add to Slack</div>
                                    </div>
                                </a>
                                }
                            </div>
                        </div>
                        <div className='w-p-5'>

                        </div>
                    </div>
                </div>
            }
            <>
                {
                    data?.length === 0 ?
                        <div className='d-flex w-p-100 flex-direction h-p-90 justify-center'>
                            <div className='d-flex align-center justify-center flex-direction'>
                                <span className="mx-auto my-2">
                                    <IntegrationGridEmptyIcon />
                                </span>
                                <span className="h4-regular color-integration-card-title mx-auto my-1">There is no integration yet.</span>
                            </div>
                        </div>
                        :
                        <div className='d-flex w-p-100 flex-direction h-p-85 o-y-scroll'>
                            {props.isIntegrationSuccess &&
                                data?.map(x =>
                                    !!x.ChannelName &&
                                    <div className='d-flex justify-between align-center h-10 bb-primary-divider-2'>
                                        <div className='w-p-20  h4-regular ml-3 w-break h-9 o-y-scroll d-flex align-center'>
                                            {x.TeamName}
                                        </div>
                                        <div className='w-p-15 h4-regular w-break ml-2 h-9 o-y-scroll d-flex align-center'>
                                            {x.ChannelName}
                                        </div>
                                        <div className='w-p-5 d-flex  justify-center'>
                                            <IntegrationBlueIcon />
                                        </div>
                                        <div className='w-p-20 '>
                                            <Autocomplete
                                                size="small"
                                                disableClearable
                                                options={phoneNumberOptions}
                                                value={UtilityService.maskPhoneNumber(x.PhoneNumber)}
                                                onChange={(event: any, newValue: any) => {
                                                    setData([...data, x.PhoneNumber = newValue.label, x.PhoneNumberId = newValue.id, x.Status = false]);
                                                }}
                                                className="m-auto autocomplete-standard "
                                                renderInput={(params) => <TextField {...params} variant="standard" label="Select Phone Number" />}
                                            />
                                        </div>
                                        <div className='w-p-30 h4-regular d-flex mx-auto justify-center'>
                                            {x.Status ?
                                                <div className='m-auto  br-1 color-secondary p-1 bg-color-primary-success'>
                                                    Connected
                                                </div>
                                                : <ButtonComponent Variant={!!x.PhoneNumber ? "primary-btn-small" : "disabled-btn-small"} ClassName="m-auto my-1" ButtonLabel={buttonLabels.LINK_PHONENMBER} OnClick={() => onClickLinkChannel(x)} />
                                            }
                                            <ButtonComponent Variant={!!x.PhoneNumber ? "secondary-btn-small" : "disabled-btn-small"} ClassName="m-auto my-1" ButtonLabel={buttonLabels.TEST_INTEGRATION} OnClick={() => onClickTestIntegration(x.ChannelId)} />

                                        </div>
                                        <div className='w-p-5 d-flex justify-center'>
                                            <span className='m-auto c-pointer' onClick={() => onClickDelete(x.ChannelId)}>
                                                <DeleteChatIcon />
                                            </span>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                }
            </>
        </>

    )
}

export default IntegrateSlackChannels;